import { useMemo } from "react";
import { ProjectContentItemDc } from "@evergis/api";

import { useSyncLayersVisibility } from "../../modules/SharedLayerList/hooks/useSyncLayersVisibility";
import { useSharedProject } from "./useSharedProject";

export const useSharedLayers = (): ProjectContentItemDc[] => {
  const project = useSharedProject();

  return useSyncLayersVisibility(project.content?.items);
};

export function useSharedLayersList(): ProjectContentItemDc[] {
  const layers = useSharedLayers();

  return useMemo(() => layers.slice().reverse(), [layers]);
}
